import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 23.25V.75m10.5 10.5L12 .75 1.5 11.25"
    }, null, -1)
  ]));
}
const arrowUp = { render };
export {
  arrowUp as default,
  render
};
//# sourceMappingURL=arrow-up.svg.js.map
